/**
 * Storage event types for real-time notifications.
 */
export enum StorageEventType {
  UPLOAD_COMPLETED = 'storage:upload-completed',
  UPLOAD_FAILED = 'storage:upload-failed',
  FILE_DELETED = 'storage:file-deleted',
  FILE_UPDATED = 'storage:file-updated',
  REPLICATION_STATUS = 'storage:replication-status',
  SOURCE_CREATED = 'storage:source-created',
  SOURCE_UPDATED = 'storage:source-updated',
  SOURCE_DELETED = 'storage:source-deleted',
  ACCOUNT_CREATED = 'storage:account-created',
  ACCOUNT_UPDATED = 'storage:account-updated',
  ACCOUNT_DELETED = 'storage:account-deleted',
  COLLECTION_CREATED = 'storage:collection-created',
  COLLECTION_UPDATED = 'storage:collection-updated',
  COLLECTION_DELETED = 'storage:collection-deleted',
  // Torrent cold-mount lifecycle (P5-T06, catalog 1.19.0 — see
  // events/catalog/storage.ts; same `storage:events` raw-channel transport,
  // re-emitted by the gateway WsStorageEventsBridge).
  TORRENT_MOUNTED = 'storage:torrent-mounted',
  TORRENT_UNMOUNTED = 'storage:torrent-unmounted',
  TORRENT_PROMOTED = 'storage:torrent-promoted',
  TORRENT_REVIVAL_SEEDED = 'storage:torrent-revival-seeded',
  TORRENT_UNAVAILABLE = 'storage:torrent-unavailable',
}

/**
 * Payload for storage events.
 *
 * `fileId` is required for backward compatibility: file events carry the file
 * id, while source/account/collection events carry the entity `_id` in it
 * (mirrored in the optional `entityId`/`entityKind` fields).
 */
export interface StorageEvent {
  type: StorageEventType;
  fileId: string;
  ownerId: string;
  data: Record<string, unknown>;
  timestamp: string;
  entityId?: string;
  entityKind?: 'file' | 'source' | 'account' | 'collection';
}

/**
 * Pub/sub channel for storage events.
 */
export const STORAGE_EVENTS_CHANNEL = 'storage:events';

/**
 * WebSocket room for storage updates.
 */
export const STORAGE_UPDATES_ROOM = 'storage:updates';
